import { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext(null);
const KEY = "active_property_id";

export function ActivePropertyProvider({ children }) {
  const [activePropertyId, setId] = useState(() => localStorage.getItem(KEY) || "");
  const setActivePropertyId = useCallback((id) => {
    setId(id || "");
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  }, []);
  return <Ctx.Provider value={{ activePropertyId, setActivePropertyId }}>{children}</Ctx.Provider>;
}

export function useActiveProperty() {
  const c = useContext(Ctx);
  return c || { activePropertyId: "", setActivePropertyId: () => {} };
}
